import 'react-datepicker/dist/react-datepicker.css';
import './Style.css';

import { ru } from 'date-fns/locale';
import { useEffect, useState } from 'react';
import DatePicker, { registerLocale } from 'react-datepicker';

import ErrorComponent from '@/components/common/error-component/ErrorComponent';
import Birthday from '@/components/ui/icons/Birthday';
import { WidgetComponent } from '@/forms/components/widget';
import { newDateFormat } from '@/helpers/dates';
import useEffectOnlyOnUpdate from '@/hooks/useEffectOnlyOnUpdate/useEffectOnlyOnUpdate';

import classes from './DateInput.module.scss';

const DateInput = ({
	label,
	name,
	placeholder,
	value,
	disabled,
	onChange,
	fieldClass,
	required,
	widgetArgs,
	resDataAfterSubmit,
	form,
	autoFocus,
	onFocus,
	onBlur,
	theme = 'shadow',
}: WidgetComponent) => {
	const elId = `id_${name}`;

	registerLocale('ru', ru);

	const [startDate, setStartDate] = useState<Date | null>(null);
	const [defaultDate, setDefaultDate] = useState<string>();

	//   const [dataAfterSubmit, setDataAfterSubmit] = useState<string | null>(
	//     null
	//   );
	const [errorAfterSubmit, setErrorAfterSubmit] = useState<string[] | null>(
		null
	);

	useEffect(() => {
		if (value && typeof value === 'string') {
			setDefaultDate(
				value.includes('-')
					? new Intl.DateTimeFormat('ru', {
							year: 'numeric',
							month: 'numeric',
							day: 'numeric',
						}).format(new Date(value))
					: value
			);
			setStartDate(newDateFormat(value));
		} else {
			setDefaultDate(undefined);
			setStartDate(null);
		}
	}, [value]);

	useEffectOnlyOnUpdate(() => {
		if (resDataAfterSubmit) {
			const { errorMessage } = resDataAfterSubmit;
			if (Object.entries(errorMessage).length > 0) {
				// eslint-disable-next-line unicorn/no-lonely-if
				if (errorMessage[name]) setErrorAfterSubmit(errorMessage[name]);
			}
		}
	}, [resDataAfterSubmit]);

	useEffect(() => {
		if (startDate && +startDate !== +new Date(value as string)) {
			if (errorAfterSubmit) {
				setErrorAfterSubmit(null);
			}

			onChange(startDate);
			setDefaultDate(undefined);
		}
	}, [startDate]);

	let isInline = widgetArgs?.is_inline;

	if (name === 'reportStartDateOpen' || name === 'reportFinishDateOpen') {
		isInline = true;
	}

	const labelAndValue = form === 'projectEditForm';

	let placeholderText;
	// eslint-disable-next-line unicorn/prefer-ternary, unicorn/no-negated-condition
	if (!placeholder) {
		placeholderText = new Date().toLocaleDateString();
	} else {
		placeholderText = placeholder;
	}

	return (
		<section
			data-error={errorAfterSubmit ? true : undefined}
			className={`
        ${
					fieldClass
						? [classes.container, fieldClass].join(' ')
						: classes.container
				} ${'react-datepicker-container-' + theme}  ${classes['container-' + theme || '']}`}
		>
			{labelAndValue ? (
				<label>
					<span>{label}</span>
					<span>{value?.toString()}</span>
				</label>
			) : (
				label && (
					<label htmlFor={elId}>
						{placeholder === 'Изменить дату' && (
							<Birthday clazz={classes.icon} />
						)}
						{label}
					</label>
				)
			)}
			<DatePicker
				className='planning'
				calendarClassName='planning'
				locale='ru'
				dateFormat='dd.MM.yyyy'
				placeholderText={placeholderText}
				selected={startDate}
				value={defaultDate}
				onChange={(date: Date | null) => {
					setStartDate(date);
				}}
				required={required}
				autoFocus={autoFocus}
				inline={isInline}
				disabled={disabled}
				name={name}
				onFocus={onFocus}
				onBlur={onBlur}
			/>
			{errorAfterSubmit?.map((i, idx) => {
				return (
					<ErrorComponent key={idx} clazz={classes.error}>
						{`*${i}`}
					</ErrorComponent>
				);
			})}
		</section>
	);
};

export default DateInput;
